import React from "react";
import { Modal, Button } from "../ui";
import { i18n } from "../../translate/i18n";

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      title={title}
      size="sm"
      footer={
        <>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => onClose(false)}
          >
            {i18n.t("confirmationModal.buttons.cancel")}
          </Button>
          <Button
            color="danger"
            onClick={() => {
              onClose(false);
              onConfirm();
            }}
          >
            {i18n.t("confirmationModal.buttons.confirm")}
          </Button>
        </>
      }
    >
      <p className="text-dark-600 dark:text-dark-400">{children}</p>
    </Modal>
  );
};

export default ConfirmationModal;
